import { IShipperApplicationStates } from 'types/graphqlTypes'
import * as yup from 'yup'

export type IShipperFilterState = IShipperApplicationStates | ''

export const ShipperFilterSchema = yup.object({
  /**
   * @example { id: '1241', text: '1720-shipper' } | null
   */
  searchTerm: yup
    .object({
      id: yup.string(),
      text: yup.string(),
    })
    .nullable()
    .default(null),
  /**
   * @example 'confirmed'
   */
  state: yup
    .mixed<IShipperFilterState | ''>()
    .oneOf([...Object.values(IShipperApplicationStates), '']),
})

export type TShipperFilterSchema = yup.InferType<typeof ShipperFilterSchema>
